
	import Modal from '@/components/Modal.vue';
	import { Component, Vue, Emit, Watch } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';

	@Observer
	@Component({
		components: { Modal }
	})
	export default class NoConnectionError extends Vue {}
